<div class="gap-2 position-relative">
  <form class="d-flex align-items-center col-12 col-md-12 col-lg-12">
    <span class="position-absolute ps-3 search-icon">
      <img src="assets/images/svg/search.svg" alt="search">
    </span>
    <input type="search" class="form-control ps-6 rounded-5"
           [ngClass]="{'bg-white' : isMobile}"
           [formControl]="searchFormControl"
           [placeholder]="placeholder"
           [value]="selectedResult"
    >
  </form>
</div>
